<script>
import Layout from "../../layouts/auth";
import {
  //authMethods,
  authFackMethods,
  // notificationMethods
} from "@/state/helpers";
import { mapState } from "vuex";
//import Alert from "../../../components/alert";
import appConfig from "@/app.config";
import { required, email } from "vuelidate/lib/validators";

/**
 * Login component
 */
export default {
  page: {
    title: "Login",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return {
      email: "",
      password: "",
      submitted: false,
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
      greet: "",
    };
  },
  validations: {
    email: { required, email },
    password: { required },
  },
  computed: {
    ...mapState("authfack", ["status"]),
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  methods: {
    //...authMethods,
    ...authFackMethods,
    //...notificationMethods,

    getGreetingMsg() {
      var hrs = new Date().getHours();

      if (hrs < 12) this.greet = this.$t("login.morning");
      else if (hrs >= 12 && hrs <= 18) this.greet = this.$t("login.afterNoon");
      else if (hrs >= 18 && hrs <= 24) this.greet = this.$t("login.evening");
      return this.greet;
    },

    // Try to log the user in with the username
    // and password they provided.

    tryToLogIn() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      } else {
        if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
          this.tryingToLogIn = true;
          // Reset the authError if it existed.
          this.authError = null;
          return (
            this.logIn({
              email: this.email,
              password: this.password,
            })
              // eslint-disable-next-line no-unused-vars
              .then((token) => {
                this.tryingToLogIn = false;
                this.isAuthError = false;
                // Redirect to the originally requested page, or to the home page
                this.$router.push(this.$route.query.redirectFrom || { name: "default" });
              })
              .catch((error) => {
                this.tryingToLogIn = false;
                this.authError = error ? error : "";
                this.isAuthError = true;
              })
          );
        } else {
          const { email, password } = this;
          if (email && password) {
            this.login({ email, password });
          }
        }
      }
    },
  },
  mounted() {
    this.getGreetingMsg();
  },
};
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-soft-primary-black">
            <div class="row">
              <div class="col-7">
                <div class="text-primary-white p-4">
                  <h5 class="text-primary-white">{{ greet }}</h5>
                  <p>{{ $t("login.message") }}</p>
                </div>
              </div>
              <div class="col-5 image-logo">
                <img
                  src="@/assets/images/new_logo.svg"
                  alt
                  class="img-fluid logo-image"
                />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <!-- <div>
              <router-link tag="a" to="/">
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img src="@/assets/images/new_logo.svg" alt height="74" />
                  </span>
                </div>
              </router-link>
            </div> -->
            <b-alert v-model="isAuthError" variant="danger" class="mt-3" dismissible>{{
              authError
            }}</b-alert>

            <div v-if="notification.message" :class="'alert ' + notification.type">
              {{ notification.message }}
            </div>
            <!--<Alert/>-->
            <b-form class="pt-4 pl-2 pr-2 pb-2" @submit.prevent="tryToLogIn">
              <b-form-group id="input-group-1" label="Email" label-for="input-1">
                <b-form-input
                  id="input-1"
                  v-model="email"
                  type="text"
                  :placeholder="$t('login.emailPlaceholder')"
                  :class="{ 'is-invalid': submitted && $v.email.$error }"
                ></b-form-input>
                <div v-if="submitted && $v.email.$error" class="invalid-feedback">
                  <span v-if="!$v.email.required">{{ $t("login.emailRequired") }}</span>
                  <span v-if="!$v.email.email">{{ $t("login.validEmail") }}</span>
                </div>
              </b-form-group>

              <b-form-group id="input-group-2" label="Password" label-for="input-2">
                <b-form-input
                  id="input-2"
                  v-model="password"
                  type="password"
                  :placeholder="$t('login.passwordPlaceholder')"
                  :class="{ 'is-invalid': submitted && $v.password.$error }"
                ></b-form-input>
                <div v-if="submitted && !$v.password.required" class="invalid-feedback">
                  {{ $t("login.passwordrequired") }}
                </div>
              </b-form-group>
              <div class="custom-control custom-checkbox">
                <input
                  id="customControlInline"
                  type="checkbox"
                  class="custom-control-input"
                />
                <label class="custom-control-label" for="customControlInline">{{
                  $t("login.rembember")
                }}</label>
              </div>
              <div class="mt-3">
                <b-button
                  type="submit"
                  variant="primary"
                  class="btn-block bg-login-black"
                  >{{ $t("login.logIn") }}</b-button
                >
              </div>
              <div class="mt-4 text-center">
                <router-link tag="a" to="/register" class="button-forgot">
                  {{ $t("login.register") }}
                </router-link>
              </div>
              <div class="mt-4 text-center">
                <router-link tag="a" to="/forgot-password" class="button-forgot">
                  <i class="mdi mdi-lock mr-1"></i> {{ $t("login.forgotpassword") }}
                </router-link>
              </div>
              <!--<div class="mt-4 text-center">
                <h5 class="font-size-14 mb-3">Sign in with</h5>

                <ul class="list-inline">
                  <li class="list-inline-item">
                    <a
                      href="javascript: void(0);"
                      class="social-list-item bg-primary text-white border-primary"
                    >
                      <i class="mdi mdi-facebook"></i>
                    </a>
                  </li>
                  <li class="list-inline-item">
                    <a
                      href="javascript: void(0);"
                      class="social-list-item bg-info text-white border-info"
                    >
                      <i class="mdi mdi-twitter"></i>
                    </a>
                  </li>
                  <li class="list-inline-item">
                    <a
                      href="javascript: void(0);"
                      class="social-list-item bg-danger text-white border-danger"
                    >
                      <i class="mdi mdi-google"></i>
                    </a>
                  </li>
                </ul>
              </div>-->
              <!--<div class="mt-4 text-center">
                <router-link tag="a" to="/forgot-password" class="text-muted">
                  <i class="mdi mdi-lock mr-1"></i> Forgot your password?
                </router-link>
              </div>-->
            </b-form>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->

        <!--<div class="mt-5 text-center">
          <p>
            Don't have an account ?
            <router-link tag="a" to="/register" class="font-weight-medium text-primary">Signup now</router-link>
          </p>
          <p>
            © {{new Date().getFullYear()}} Skote. Crafted with
            <i class="mdi mdi-heart text-danger"></i> by Themesbrand
          </p>
        </div>-->
        <!-- end row -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style lang="scss" module></style>
<style>
.text-primary-white {
  color: #fff;
}
.bg-soft-primary-black {
  background-color: #1c1c1e !important;
}
.bg-login-black {
  background-color: #1c1c1e !important;
  border-color: #1c1c1e !important;
}
.logo-image {
  height: 125px;
  width: 220px;
  object-fit: contain;
  /* right: 0;
  text-align: right; */
}
.button-forgot {
  color: #d6542d;
}
.button-forgot:hover {
  color: #d6542d !important;
}
.image-logo {
  margin-top: -10px;
  margin-bottom: 2px;
}
</style>
